import { responseError } from "@/lib/response-error";
// Resolves a manifest audioPath to a playable URL.
//
// - Absolute paths and full URLs ("/...", "http...") are used as-is. This keeps
//   local dev and any already-public asset working without a round-trip.
// - Anything else is treated as a private S3 object key and exchanged for a
//   short-lived presigned URL via the server. Results are cached in-memory for
//   the page lifetime (presigned URLs are valid ~1h, longer than a sitting).

const cache = new Map<string, Promise<string>>();

export function resolveAudioUrl(audioPath: string): Promise<string> {
  if (audioPath.startsWith("/") || audioPath.startsWith("http")) {
    return Promise.resolve(audioPath);
  }
  const cached = cache.get(audioPath);
  if (cached) return cached;

  const pending = fetch(
    `/api/internal/tts-arena/audio-url?key=${encodeURIComponent(audioPath)}`
  )
    .then(async (r) => {
      if (!r.ok) throw await responseError(r, "Failed to load evaluation audio");
      return r.json() as Promise<{ url: string }>;
    })
    .then((j) => j.url)
    .catch((err) => {
      cache.delete(audioPath); // allow retry on next play
      throw err;
    });

  cache.set(audioPath, pending);
  return pending;
}
